<template>
  <div class="reportWrapper">
    <div class="report-component" id="tr-trends-10-html">
      <div class="trends-10-image scrollable-image">
        <img :src="cwaData.ImageBase64" alt="Trends 10 Image" />
      </div>
      <h4 class="margin-top">Overview</h4>
      <div class="overview" v-html="cwaData.OverviewText"></div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    name: 'Trends10Template',
    props: {
      cwaData: {
        type: Object,
        required: false,
        default: () => ({
          ImageBase64: '',
          OverviewText: '',
        }),
      },
    },
    data: () => ({}),
    created() {},
    mounted() {},
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .trends-10-image {
  }
  .overview {
    * {
      font-size: 17px !important;
      color: var(--itr-charcoal) !important;
      background-color: transparent !important;
      font-family: 'Open Sans', sans-serif !important;
    }
  }
</style>
